import DescriptionIcon from '@mui/icons-material/Description';
import { Box, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

const EmptyFeedbacks = () => {
	const classes = {
		feedbackIcon: {
			fontSize: 180,
			opacity: 0.1,
		},
	};
	const { t } = useTranslation('candidate-feedback');

	return (
		<Box
			width="100%"
			height="100%"
			display="flex"
			justifyContent="center"
			alignItems="center"
			flexDirection="column"
		>
			<Box>
				<DescriptionIcon sx={classes.feedbackIcon} color="primary" />
			</Box>
			<Box display="flex" flexDirection="row" justifyContent="center" alignItems="center">
				<Typography variant="h5">{t('no_feedbacks')}</Typography>{' '}
			</Box>
		</Box>
	);
};

EmptyFeedbacks.propTypes = {};

export default EmptyFeedbacks;
